import React from "react"
import { Send } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { forgotPassword } from "../api/apiClient"

const ForgotPasswordPage = () => {
  const navigate = useNavigate()
  const [email, setEmail] = React.useState("")
  const [status, setStatus] = React.useState("idle") // idle, loading, success, error
  const [message, setMessage] = React.useState("")

  const handleSubmit = async () => {
    if (!email) return
    setStatus("loading")
    setMessage("")
    try {
      await forgotPassword(email)
      setStatus("success")
      setMessage("If an account exists for this email, a reset link has been sent.")
    } catch (err) {
      setStatus("error")
      setMessage(err.message || "Failed to send reset link.")
    }
  }

  return (
    <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-2xl">
      <h2 className="text-3xl font-bold mb-6 text-gray-800 text-center flex items-center justify-center">
        <Send className="w-6 h-6 mr-2 text-yellow-600" /> Reset Password
      </h2>
      
      {status === "success" ? (
        <div className="text-center">
          <div className="bg-green-100 text-green-700 p-4 rounded-lg mb-6">
            {message}
          </div>
          <p className="text-gray-600 mb-6">
            Please check your email inbox and spam folder.
          </p>
        </div>
      ) : (
        <>
          <p className="text-gray-600 mb-6 text-center">
            Enter your email address to receive a password reset link.
          </p>
          
          {status === "error" && (
            <div className="bg-red-100 text-red-700 p-3 rounded-lg mb-4 text-sm">
              {message}
            </div>
          )}

          <input
            className="w-full p-3 mb-6 border border-gray-300 rounded-lg"
            placeholder="Email Address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <button
            onClick={handleSubmit}
            disabled={status === "loading"}
            className="w-full py-3 bg-yellow-600 text-white font-semibold rounded-lg hover:bg-yellow-700 transition duration-150 shadow-md disabled:opacity-50"
          >
            {status === "loading" ? "Sending..." : "Send Reset Link"}
          </button>
        </>
      )}

      <p className="mt-6 text-center text-sm">
        <button
          onClick={() => navigate("/login")}
          className="text-indigo-600 hover:text-indigo-800 transition duration-150"
        >
          Back to Login
        </button>
      </p>
    </div>
  )
}

export default ForgotPasswordPage
